// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3330": "1852a85d","494": "40775784","8795": "631c6af3",}[chunkId] + ".css"
}